import axios from "axios";
import config from "../../config.json";

export const fetchMyOrders = async () => {
  try {
    // const response = await axios.get("/orders/my-orders");
    const response = await axios.get(`${config.dev}/v2/order/my-orders`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des commandes :", error);
    throw error.response?.data || { message: "Erreur inattendue." };
  }
};

export const updateOrderStatus = async (
  orderNumber,
  newStatus,
  rejectReason,
  estimatedPreparationTime
) => {
  try {
    const payload = { status: newStatus };
    if (rejectReason) payload.rejectReason = rejectReason;
    if (estimatedPreparationTime)
      payload.estimatedPreparationTime = estimatedPreparationTime;

    const response = await axios.put(
      `${config.dev}/v2/order/update-status/${orderNumber}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Erreur de mise à jour :", error);
    throw error;
  }
};

export const markOrderAsPaid = async (orderNb) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/order/mark-paid/${orderNb}`
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du paiement :", error);
  }
};

export const fetchConnectedUser = async () => {
  const token = localStorage.getItem("tokenLogin");

  const res = await axios.get(`${config.dev}/user/getAdminData`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const updateOrderpreparationTime = async (orderNumber, newTime) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/order/${orderNumber}/preparation-time`,
      { newTime } // ← passer la valeur en minutes
    );
    return response.data;
  } catch (error) {
    console.error("Erreur de mise à jour :", error);
  }
};

export const fetchOrderById = async (id) => {
  try {
    const response = await axios.get(`${config.dev}/v2/order/by-id/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération d'une commande :", error);
    throw (
      error.response?.data || {
        message: "Unexpected error while retrieving an order.",
      }
    );
  }
};

export const sendReceipt = async (orderNumber) => {
  try {
    const response = await axios.post(
      `${config.dev}/v2/order/${orderNumber}/send-receipt`
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ Error while sending receipt:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Failed to send receipt");
  }
};

export const deleteAllOrders = async () => {
  try {
    const res = await axios.delete(
      `${config.dev}/v2/order/delete-all`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error deleting all orders:", error);
    throw error;
  }
};
